import React, {useContext, useEffect, useState} from 'react';
import './NewTask.css'
import {Context} from "../../index";
import {observer} from "mobx-react-lite";
import {fetchUsers} from "../../http/UserAPI";
import {useNavigate} from "react-router-dom";
import fileImg from "../../accets/img/file.png";
import PreloaderNewTask from "../Preloader/PreloaderNewTask";

const NewTask = () => {

    const {userStore, priorityStore, taskStore} = useContext(Context)

    const navigate = useNavigate()

    const [nameTask, setNameTask] = useState('')
    const [infoTask, setInfoTask] = useState('')
    const [priorityTask, setPriorityTask] = useState(0)
    const [file, setFile] = useState(null)
    const [allUsers, setAllUsers] = useState([])
    const [executor, setExecutor] = useState(0)
    const [loadingNewTask, setLoadingNewTask] = useState(false)

    useEffect(() => {
        fetchUsers().then(data => setAllUsers(data))
    }, [])

    const addTask = () => {
        setLoadingNewTask(true)
        if (executor === 0) {
            if (!file) {
                const formData = new FormData()
                formData.append('name', nameTask)
                formData.append('description', infoTask)
                formData.append('executor', executor)
                formData.append('priority', priorityTask)
                formData.append('status', 'NEW')
                formData.append('userId', userStore.user.id)
                taskStore.addTask(formData).then(data =>
                        setNameTask(''),
                    setInfoTask(''),
                    setPriorityTask(0),
                    setExecutor(0)
                )

            }

            if (file) {
                const formData = new FormData()
                formData.append('name', nameTask)
                formData.append('description', infoTask)
                formData.append('file', file)
                formData.append('executor', executor)
                formData.append('priority', priorityTask)
                formData.append('status', 'NEW')
                formData.append('userId', userStore.user.id)
                taskStore.addTaskFile(formData).then(data =>
                        setNameTask(''),
                    setInfoTask(''),
                    setPriorityTask(0),
                    setFile(null),
                    setExecutor(0)
                )
            }
            setTimeout(() => {
                setLoadingNewTask(false)
                navigate(`/job/task/${taskStore.taskId}`)
            }, 1000)
        }

        if (executor !== 0) {
            if (!file) {
                const formData = new FormData()
                formData.append('name', nameTask)
                formData.append('description', infoTask)
                formData.append('executor', executor)
                formData.append('priority', priorityTask)
                formData.append('status', 'NEW')
                formData.append('userId', userStore.user.id)
                taskStore.addTaskToMsg(formData).then(data =>
                        setNameTask(''),
                    setInfoTask(''),
                    setPriorityTask(0),
                    setExecutor(0)
                )

            }

            if (file) {
                const formData = new FormData()
                formData.append('name', nameTask)
                formData.append('description', infoTask)
                formData.append('file', file)
                formData.append('executor', executor)
                formData.append('priority', priorityTask)
                formData.append('status', 'NEW')
                formData.append('userId', userStore.user.id)
                taskStore.addTaskFileToMsg(formData).then(data =>
                        setNameTask(''),
                    setInfoTask(''),
                    setPriorityTask(0),
                    setFile(null),
                    setExecutor(0)
                )
            }
            setTimeout(() => {
                setLoadingNewTask(false)
                navigate(`/job/task/${taskStore.taskId}`)
            }, 1000)
        }

    }

    return (
        <div className="ml">
            {loadingNewTask ? <PreloaderNewTask/> : null}
            <div className="task__name__block">
                <div className="title__task">Создание новой задачи</div>
                <div className="btn__block">
                    <button onClick={addTask}>Создать</button>
                    <button onClick={() => navigate('/job/task')}>Отмена</button>
                </div>
            </div>

            <div className="input__block">
                <div className="name__input">Наименование задачи</div>
                <textarea onChange={e => setNameTask(e.target.value)} value={nameTask} type="text"
                          placeholder="Суть задачи..."/>
            </div>

            <div className="input__block input__block__info">
                <div className="name__input">Подробности задачи</div>
                <textarea onChange={e => setInfoTask(e.target.value)} value={infoTask} type="text"
                          placeholder="Полная информация по задаче..."/>
            </div>

            <div className="priority__block">
                <div className="name__cat">Приоритет</div>
                <select onChange={e => setPriorityTask(e.target.value)} value={priorityTask} className="select__css">
                    <option>Выбор...</option>
                    {priorityStore.priority.map(priority =>
                        <option
                            onClick={() => setPriorityTask(priority)}
                            key={priority.id}
                            value={priority.id}
                        >
                            {priority.name}
                        </option>
                    )}
                </select>
                <h4>Выберите важность данной задачи, если есть такая нужда </h4>
            </div>

            <div className="priority__block">
                <div className="name__cat">Исполнитель</div>
                <select onChange={e => setExecutor(e.target.value)} value={executor} className="select__css">
                    <option>Выбор...</option>
                    {allUsers.map(users =>
                        <option
                            onClick={() => setExecutor(users)}
                            key={users.id}
                            value={users.id}
                        >
                            {users.firstName} {users.secondName}
                        </option>
                    )}
                </select>
                <h4>Выберите исполнителя для задачи</h4>
            </div>

            <div className="priority__block">
                <div className="name__cat">Прикрепить</div>
                <div className="input-file-row">
                    <label className="input-file">
                        <input onChange={e => setFile(e.target.files[0])} type="file" name="file" accept="*"></input>

                    </label>
                    <div className="input-file-list"></div>
                </div>
                <h4>Выберите файл для закрепления к задаче</h4>
            </div>

            {file
                &&
                <h4 className="add__file__title">Добавленные файлы к задаче:</h4>
            }

            {file
                ?
                <div className="priority__block__files priority__block__files__add">

                        <div key={file.name} className="file__task__block">
                            <img src={fileImg} alt={file.name}></img>
                            <div className="file__name">{file.name}</div>
                        </div>

                </div>
                : null
            }
        </div>
    );
};

export default observer(NewTask);